import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
function EllipsisSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-0.5"><Skeleton className="h-2 w-2 rounded-none" /><Skeleton className="h-2 w-2 rounded-none" /><Skeleton className="h-2 w-2 rounded-none" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { EllipsisSkeleton };